module.exports = __webpack_public_path__ + "static/Teri3-d90a247f0ce4134921d9b6340820ce8b.jpg";